// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"ArchiveEntityModal_bodyWrapper__ePD15"};